import { UploadDocumentType } from '@/constants/businessConstants'
import { StateRegistrationTooltip } from '../PracticeProfileTooltips'

import { UploadItem } from './UploadItem'

import { UserDocumentCategoryIdentifier } from '@/features/admin/user-document-categories/userDocumentCategory.constants'

export const FormStateRegistrationUploadItem = ({
  businessEntity,
  uploadButtonOnly,
}: {
  businessEntity?: string
  uploadButtonOnly?: boolean
}) => {
  return (
    <UploadItem
      label="State Registration"
      popUpContent={<StateRegistrationTooltip />}
      documentCategory={UserDocumentCategoryIdentifier.stateRegistration}
      documentType={UploadDocumentType.INCORPORATION}
      additionalTrackingProperties={{
        document_category: 'state_registration',
        business_entity: businessEntity,
      }}
      uploadButtonOnly={uploadButtonOnly}
    />
  )
}
